$(document).ready(function () {
 
  $('.slider_wrapper').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 16000,
    fade: true,
    cssEase: 'linear',
    adaptiveHeight: true,
    prevArrow: $(".slider_section .left_arrow .prev"),
    nextArrow: $(".slider_section .right_arr .next")
  });

  // $('.collection_sec .row').slick({
  //   dots: false,
  //   arrows: true,
  //   infinite: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   speed: 3000,
  // focusOnSelect: true,
  // pauseOnHover:true,
  //   prevArrow: $(".collection_sec .left_arrow .prev"),
  //   nextArrow: $(".collection_sec .right_arr .next"),
  //   responsive: [
  //   {
  //     breakpoint: 1320,
  //     settings: {
  //       arrows: false,
  //       slidesToShow: 2,
  //     }
  //   },
  //   {
  //     breakpoint: 991,
  //     settings: {
  //       arrows: false,
  //       slidesToShow: 1,
  //       adaptiveHeight: true
  //     }
  //   }
  // ]
  // });

  $('.our_team .row').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    prevArrow: "<img class='slick-prev' src='//cdn.shopify.com/s/files/1/0609/8072/3852/t/1/assets/prev.png?v=1661318028'>",
    nextArrow: "<img class='slick-next' src='//cdn.shopify.com/s/files/1/0609/8072/3852/t/1/assets/next.png?v=1661318477'>",
    responsive: [
    {
      breakpoint: 991,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 1,
      }
    }
  ]
  });


$('.textmonial_wrapper1').slick({
  centerMode: true,
  centerPadding: '0px',
  slidesToShow: 3,
  infinite: true,
  autoplay: true,
  prevArrow: $(".textmonial_sec .left_arrow .prev"),
  nextArrow: $(".textmonial_sec .right_arr .next"),
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
      }
    }
  ]
});


  $('.addition_wrapper').slick({
  centerMode: true,
  centerPadding: '0px',
  slidesToShow: 3,
  infinite: true,
  autoplay: true,
  prevArrow: $(".new_addition .left_arrow .prev"),
  nextArrow: $(".new_addition .right_arr .next"),
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: false,
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 1,
      }
    }
  ]
});


    $('.pd_spcf_tab_list .row').slick({
      arrows: true,
  slidesToShow: 3,
  infinite: true,
  autoplay: true,
  prevArrow: $(".pd_spcf_tab_list .left_arrow .prev"),
  nextArrow: $(".pd_spcf_tab_list .right_arr .next"),
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: false,
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 1,
      }
    }
  ]
});


  $('ul.recomend_pro').slick({
  arrows: true,
  slidesToShow: 3,
  infinite: true, 
  autoplay: true,
  // prevArrow: $(".left_arrow .prev"), 
  // nextArrow: $(".right_arr .next"),
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: false, 
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 1,
      }
    }
  ]
});

    $('.title_poem_inner1').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true
  });

  
$('.meassage_us_inner').slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 100000,
  speed: 3000,
  adaptiveHeight: true,
  focusOnSelect: true,
  pauseOnHover:true,
  prevArrow: $(".meassage_us_sec .left_arrow .prev"),
  nextArrow: $(".meassage_us_sec .right_arr .next"),
});


$('.qoutes_box').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    adaptiveHeight: true,
    fade: true,
    autoplaySpeed: 80000, 
  });



var addcartforlowerlength = $('.title_poem_inner').find('.title_poem_box').length;

if (addcartforlowerlength === 0 ) {
$('.slick-dots').css("display","none"); 
 $('.title_poem').css("display","none"); 
}       



$('.rm').click(function() {
  $('.moretext').slideToggle();
  if ($('.rm').text() == "Read More") {
    $(this).text("Read less")
  } else {
    $(this).text("Read More")
  }
});


  
 });

// window.onscroll = function() {scrollFunction()};


// function scrollFunction() {
//   if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
//     document.getElementsByClassName("header-wrapper").style.top = "0";
//   } else {
//     document.getElementsByClassName("header-wrapper").style.top = "-80px";
//   }
// }



